import React, { Component } from "react";
import { connect } from 'react-redux'
import $ from 'jquery';
import AddBrand from "./AddBrand";
import StepWizard from 'react-step-wizard';
import BrandCSV from "./BrandCSV";
import BrandOrder from "./BrandOrder";
import { withRouter } from 'react-router-dom';
import BrandOrderWorkflow from "./BrandOrderWorkflow";
import ExportDataAttribute from "./ExportDataAttribute";
import { brandActions } from "../../../redux/actions/brand-actions";
import { confirmAlert } from 'react-confirm-alert';
import ConfirmAlert from '../../ThemeComponents/confirmAlert';

class BrandWizard extends Component {
	_isMounted = false;

	constructor(props) {
		super(props);
		this.state = {
			brand: {},
			brandProdAtts: [],
			brandOrderAtts: [],
			brandOrder: false,
			showWorkflow: false,
			showExportAtts: false,
			endWizard: false,
			wizardType: '',
			step: 0,
			brandAdded: true,
			quantity_length: [],
			export_length: [],
			data_definition: {
				id: ''
			},
			complete_definition: {},
			view_mode: false,
		}
	}
	handleBrand = (brandData) => {
		if (this._isMounted) {
			this.setState({
				brand: brandData,
				brandAdded: false,
			})
		}
	}
	handleProdAtts = (data, quantity_length, export_length) => {
		this.setState({
			...this.state,
			brandProdAtts: data.product_attributes,
			brandOrderAtts: data.order_attributes,
			brandOrder: true,
			brandAdded: false,
			quantity_length: quantity_length,
			export_length: export_length,
			complete_definition: data,
		})
	}

	handleOrderAtts = (data) => {
		this.setState({
			brandOrderAtts: data.order_attributes,
			showExportAtts: true,
			complete_definition: data,

		})
	}

	handleExportAtts = (data) => {
		this.setState({
			...this.state,
			showWorkflow: data.export_attributes,
			complete_definition: data,
		})
	}
	WizardFinishHandler = async (endWizard) => {
		console.log('%c Success! ', 'background: #222; color: #bada55');
		return;
	}


	setStateWithType = (type) => {

	}

	cloneVersion = async (id) => {
		// data/definition/{brand_data_definition}/clone
		try {
			const res = await this.props.cloneDataDefinitionCall(this.props.location.state.data_definition.id);
			this.props.history.goBack();
		} catch (e) {

		}

	}

	completedWizardValidation = () => {
		confirmAlert({
			childrenElement: () => <div />,
			customUI: ({ onClose }) => <ConfirmAlert
				header="Completed Wizard"
				description="This version is already completed. Do you want to clone this version?"
				onClosePro={() => { this.props.history.goBack(); onClose() }}
				onYes={this.cloneVersion}
			/>
		})
	}

	componentDidMount() {
		this._isMounted = true;
		const { state } = this.props.location;
		if (state !== undefined && !state.view_mode) {
			this.props.editBrandDataDefinitionCall(state.data_definition.id, 'edit').then(res => {
				this.setState({
					...this.state,
					wizardType: 'edit',
					view_mode: state.view_mode ? state.view_mode : false
				})
			})
				.catch(error => {

					console.log('WIZARARAADAD', error);
					this.completedWizardValidation();
				})
				;
		}
		else if (state !== undefined && state.view_mode) {
			console.log('view ran')
			this.props.editBrandDataDefinitionCall(state.data_definition.id, 'view').then(res => {
				this.setState({
					...this.state,
					wizardType: 'edit',
					view_mode: state.view_mode ? state.view_mode : false
				})
			})
				.catch(error => {
					this.props.history.goBack();
				})
				;

		}
		else {
			this.setState({
				wizardType: 'add',
			})
		}
	}

	setWizardHeight = () => {
		// if($(".rsw_2Y").height() !== $(".rsw_3G").outerHeight()){
		// $(".rsw_2Y").height($(".rsw_3G").outerHeight());
		setTimeout(function () {
			$("html,body").stop(true, true).animate({ scrollTop: '0' }, 500, "linear")
		}, 300)
		// }
	}
	componentWillUnmount() {
		this._isMounted = false;
	}
	componentDidUpdate(prevProps) {
		if (this.props.editDataDefinition !== prevProps.editDataDefinition) {
			const { editDataDefinition } = this.props;
			const { state } = this.props.location;
			this.setState({
				data_definition: {
					id: editDataDefinition.id
				},
			})
			if (editDataDefinition.product_attributes_added == 0) {
				this.setState({
					step: 1,
				})
			}

			else if (editDataDefinition.product_attributes_added == 1 && editDataDefinition.order_attributes_added == 0) {
				this.setState({
					brandProdAtts: editDataDefinition.product_attributes
				}, () => {
					if (state.type === 'product') {
						this.setState({
							step: 1,
						})
					}
					else if (state.type === 'order') {
						this.setState({
							step: 2,
						})
					}
					else if (state.type === 'export') {
						this.setState({
							step: 2,
						})
					}
					else if (state.type === 'order_steps') {
						this.setState({
							step: 2,
						})
					}
					else {
						return
					}
				})
			}

			else if (editDataDefinition.product_attributes_added == 1 && editDataDefinition.order_attributes_added == 1 && editDataDefinition.export_attributes_added == 0) {
				this.setState({
					brandProdAtts: editDataDefinition.product_attributes
				}, () => {
					if (state.type === 'product') {
						this.setState({
							step: 1,
						})
					}
					else if (state.type === 'order') {
						this.setState({
							step: 2,
						})
					}

					else if (state.type === 'export') {
						this.setState({
							step: 3,
						})
					}
					else if (state.type === 'order_steps') {
						this.setState({
							step: 3,
						})
					}
					else {
						return
					}
				})
			}

			else if (editDataDefinition.product_attributes_added == 1 && editDataDefinition.order_attributes_added == 1 && editDataDefinition.export_attributes_added == 1 && editDataDefinition.order_workflow_added == 0) {
				if (state.type === 'product') {
					this.setState({
						step: 1,
					})
				}
				else if (state.type === 'order') {
					this.setState({
						step: 2,
					})
				}

				else if (state.type === 'export') {
					this.setState({
						step: 3,
					})
				}

				else if (state.type === 'order_steps') {
					this.setState({
						step: 4,
					})
				}
				else {
					return;
				}
			}

			else if (editDataDefinition.product_attributes_added == 1 && editDataDefinition.order_attributes_added == 1 && editDataDefinition.export_attributes_added == 1 && editDataDefinition.order_workflow_added == 1) {
				// this.setState({
				// 	step: 4,
				// })

				if (state.type === 'product') {
					this.setState({
						step: 1,
					})
				}
				else if (state.type === 'order') {
					this.setState({
						step: 2,
					})
				}

				else if (state.type === 'export') {
					this.setState({
						step: 3,
					})
				}

				else if (state.type === 'order_steps') {
					this.setState({
						step: 4,
					})
				}
				else {
					return;
				}
			}

			else if (editDataDefinition.product_attributes_added == 1 && editDataDefinition.order_attributes_added == 1 &&
				editDataDefinition.export_attributes_added == 1) {

				if (state.type === 'product') {
					this.setState({
						step: 1,
					})
				}
				else if (state.type === 'order') {
					this.setState({
						step: 2,
					})
				}

				else if (state.type === 'export') {
					this.setState({
						step: 3,
					})
				}
				else {
					return
				}
			}

			else if (editDataDefinition.product_attributes_added == 1 &&
				editDataDefinition.order_attributes_added == 1) {
				if (state.type === 'product') {
					this.setState({
						step: 1,
					})
				}
				else if (state.type === 'order') {
					this.setState({
						step: 2,
					})
				}
				else {
					return
				}
			}

			else if (editDataDefinition.product_attributes_added == 1) {
				this.setState({
					step: 1,
				})
			}
			else {
				console.log('nothing was matched')
			}
		}
	}

	render() {
		return (
			<div className="content">
				{
					this.state.wizardType === 'add' ?
						<React.Fragment>
							<React.Fragment>
								{
									this.state.brandAdded &&
									<AddBrand brandHandler={this.handleBrand} />
								}
							</React.Fragment>
							<React.Fragment>
								{
									!this.state.brandAdded &&
									<StepWizard onStepChange={this.setWizardHeight} >
										<BrandCSV storedBrand={this.state.brand.data_definition} productAttsHandler={this.handleProdAtts} fetchedProductAttributes={this.props.location.state}
										/>

										<BrandOrder storedBrand={this.state.brand.data_definition} productAtts={this.state.brandProdAtts !== [] ? this.state.brandProdAtts : []} orderAttsHandler={this.handleOrderAtts} quantityLength={this.state.quantity_length !== [] ? this.state.quantity_length : []} />

										<ExportDataAttribute storedBrand={this.state.brand.data_definition} exportsHandler={this.handleExportAtts} productAttributes={this.state.brandProdAtts !== [] ? this.state.brandProdAtts : []} orderAttributes={this.state.brandOrderAtts !== [] ? this.state.brandOrderAtts : []} exportLength={this.state.export_length !== [] ? this.state.export_length : []} />

										<BrandOrderWorkflow storedBrand={this.state.brand.data_definition} orderWorkflowHandler={this.hanldleOrderWorkflow} productAttributes={this.state.brandProdAtts !== [] ? this.state.brandProdAtts : []} />
									</StepWizard>
								}
							</React.Fragment>
						</React.Fragment>
						:
						// the edit wizard
						<React.Fragment>
							<React.Fragment>
								{
									this.props.editDataDefinition && this.state.step !== 0 &&
									<StepWizard initialStep={this.state.step} onStepChange={this.setWizardHeight} >

										<BrandCSV
											storedBrand={this.state.data_definition}
											productAttsHandler={this.handleProdAtts}
											fetchedProductAttributes={this.props.editDataDefinition} complete_definition={this.state.complete_definition}
											view_mode={this.state.view_mode}
										/>

										<BrandOrder
											storedBrand={this.state.data_definition}
											productAtts={this.state.brandProdAtts !== [] ? this.state.brandProdAtts : []}
											orderAttsHandler={this.handleOrderAtts} fetchedOrderAttributes={this.props.editDataDefinition}
											quantityLength={this.state.quantity_length !== [] ? this.state.quantity_length : []}
											complete_definition={this.state.complete_definition}
											view_mode={this.state.view_mode}

										/>

										<ExportDataAttribute
											storedBrand={this.state.data_definition}
											exportsHandler={this.handleExportAtts}
											productAttributes={this.state.brandProdAtts !== [] ? this.state.brandProdAtts : []}
											orderAttributes={this.state.brandOrderAtts !== [] ? this.state.brandOrderAtts : []}
											fetchedExportAttributes={this.props.editDataDefinition}
											exportLength={this.state.export_length !== [] ? this.state.export_length : []}
											complete_definition={this.state.complete_definition}
											view_mode={this.state.view_mode}

										/>

										<BrandOrderWorkflow
											storedBrand={this.state.data_definition} orderWorkflowHandler={this.hanldleOrderWorkflow}
											productAttributes={this.state.brandProdAtts !== [] ? this.state.brandProdAtts : []} fetchedOrderWorkflow={this.props.editDataDefinition}
											brandId={this.props.location.state.brandId}
											view_mode={this.state.view_mode}
										/>
									</StepWizard>
								}
							</React.Fragment>
						</React.Fragment>
				}
			</div>

		);
	};
}
// after order is saved the fecteched prodcut atts are not saved with it in the exportables
const mapDispatchToProps = dispatch => {
	return ({
		storeBrandCall: (brandData) => { return dispatch(brandActions.storeBrand(brandData)) },
		storeBrandProductAttsCall: (brandData, id) => { return dispatch(brandActions.storeBrandProductAtts(brandData, id)) },
		storeBrandOrderAttsCall: (brandData, id) => { return dispatch(brandActions.storeBrandOrderAtts(brandData, id)) },
		editBrandDataDefinitionCall: (id, type) => { return dispatch(brandActions.editBrandDataDefinition(id, type)) },
		cloneDataDefinitionCall: (id) => { return dispatch(brandActions.cloneDataDefinition(id)) },
	});
};

function mapStateToProps(state) {
	const { brand, editDataDefinition } = state.brandReducer;
	return {
		brand,
		editDataDefinition
	};
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandWizard));


// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandWizard.jsx